import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CCard, CCardBody, CCardFooter, CCardText, CCardTitle } from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilChevronRight } from "@coreui/icons";
import type { TradingStrategyDto } from "../../api/hooks/useTradingStrategies";
import { routePaths } from "../../routes/route-paths";
import { StrategyIdentityBand } from "../trading-strategies/components/StrategyIdentityBand";
import { StrategyCurve } from "../trading-strategies/components/StrategyCurve";
import { StrategySidesTable } from "../trading-strategies/components/StrategySidesTable";

/**
 * A strategy in a membership the customer doesn't hold. Shaped like My strategies' included card, but it opens
 * the strategy's public page, since nothing gives the customer access to it yet.
 */
export function TierStrategyCard({ sides, tierName }: { sides: TradingStrategyDto[]; tierName: string }) {
  const { t } = useTranslation("memberships");

  const strategy = sides[0];

  return (
    <Link to={routePaths.strategyDetails.replace(":id", strategy.id)} className="card-link">
      <CCard>
        <StrategyIdentityBand strategy={strategy} />
        <CCardBody className="d-flex flex-column">
          <CCardTitle>{strategy.publicName}</CCardTitle>
          <CCardText
            className="text-body-secondary"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {strategy.description}
          </CCardText>
          <div className="mt-auto">
            <StrategyCurve strategy={strategy} />
            <StrategySidesTable sides={sides} />
          </div>
        </CCardBody>
        <CCardFooter className="bg-body-tertiary d-flex align-items-center gap-2">
          <small className="text-body-secondary flex-grow-1">{t("detail.includedIn", { tier: tierName })}</small>
          <CIcon icon={cilChevronRight} size="xl" className="card-link-chevron" aria-hidden />
        </CCardFooter>
      </CCard>
    </Link>
  );
}
